<template>
  <div class="attitude-wrap">
    <div class="favor">
      <el-tooltip :content="favorContent" placement="bottom" effect="light">
        <el-button type="text" @click="_expressAttitude(1)"><img class="favor-image" :src="favorPic" ></el-button>
      </el-tooltip>
      <span class="number">{{attitude.favorList.length}}</span>
    </div>
    <div class="oppo">
      <el-tooltip :content="oppositionContent" placement="bottom" effect="light">
        <el-button type="text" @click="_expressAttitude(2)"><img class="oppo-image" :src="oppositionPic" > </el-button>
      </el-tooltip>
      <span class="number">{{attitude.oppList.length}}</span>
    </div>
  </div>
</template>

<script>

import { expressAttitude, getAttitudeList } from '@/api/attitude'
import moment from 'moment'
export default {
  name: 'attitude',
  data () {
    return {
      objectId: 0,
      type: 0,
      favorContent: '赞成',
      oppositionContent: '反对',
      // 态度信息
      attitude: {
        favorFlag: false,
        oppositionFlag: false,
        favorList: [],
        oppList: [],
        favorTime: 0,
        oppositionTime: 0
      },
      favorPic: require('@/common/image/icon/attitude/favor.png'),
      oppositionPic: require('@/common/image/icon/attitude/opposition.png')
    }
  },
  mounted () {
    this.objectId = this.objectIdPop
    this.type = this.objectTypePop
    this._getAttitudeList()
  },
  // 传递值
  props: {
    objectIdPop: Number,
    objectTypePop: Number
  },
  watch: {
    objectIdPop () {
      this.objectId = this.objectIdPop
    },
    objectTypePop () {
      this.type = this.objectTypePop
    }
  },
  methods: {
    // 评价
    _expressAttitude (attitudeType) {
      let that = this
      let confirm = false
      if (attitudeType === 2) {
        confirm = !that.attitude.oppositionFlag
      } else {
        confirm = !that.attitude.favorFlag
      }
      let data = {
        'attitudeType': attitudeType,
        'objectId': that.objectId,
        'type': that.type,
        'confirm': confirm
      }
      expressAttitude(data).then(res => {
        if (res.message.code === 0) {
          that.attitude = res.data
          that.handleImage(attitudeType, confirm)
          that.handleContent(that.attitude)
          this.$message({ message: '成功', showClose: true, type: 'success' })
        } else {
          this.$message({ message: res.message.message, showClose: true, type: 'error' })
        }
      })
    },
    // 获取评价列表
    _getAttitudeList () {
      let that = this
      let data = new FormData()
      data.append('type', that.type)
      data.append('objectId', that.objectId)
      getAttitudeList(data).then(res => {
        if (res.message.code === 0) {
          that.attitude = res.data
          that.handleImage(2, that.attitude.oppositionFlag)
          that.handleImage(1, that.attitude.favorFlag)
          that.handleContent(that.attitude)
        } else {
          console.log(res.message)
        }
      })
    },
    handleContent (attitude) {
      let that = this
      if (attitude.favorTime > 0) {
        that.favorContent = '最近一次点赞发生在 ' + moment(that.attitude.favorTime).format('YYYY-MM-DD HH:mm:ss')
      } else {
        that.favorContent = '赞成'
      }
      if (attitude.oppositionTime > 0) {
        that.oppositionContent = '最近一次反对发生在 ' + moment(that.attitude.oppositionTime).format('YYYY-MM-DD HH:mm:ss')
      } else {
        that.oppositionContent = '反对'
      }
    },
    handleImage (attitudeType, confirm) {
      let that = this
      if (attitudeType === 2) {
        if (confirm) {
          that.oppositionPic = require('@/common/image/icon/attitude/opposition2.png')
        } else {
          that.oppositionPic = require('@/common/image/icon/attitude/opposition.png')
        }
      } else {
        if (confirm) {
          that.favorPic = require('@/common/image/icon/attitude/favor2.png')
        } else {
          that.favorPic = require('@/common/image/icon/attitude/favor.png')
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.attitude-wrap
  width 160px
  height 43px
  text-align right
  .number
    font-size 14px
  .favor
    height 100%
    margin-right 15px
    display inline-block
    .favor-image
      width 18px
      vertical-align middle
    .favor-image:hover
      width 20px
      transform translateY(-4px)
  .oppo
    height 100%
    display inline-block
    .oppo-image
      width 18px
      vertical-align middle
    .oppo-image:hover
      width: 20px
      transform translateY(2px)
</style>
